import styled from "styled-components";
import {
    border,
    borderRadius,
    flexbox,
    layout,
    margin,
    padding,
} from "styled-system";
import { gap } from "../../shared/helpers/styleHelpers";
export const Flex = styled("div")(
    { display: "flex", gap: "1rem" },
    flexbox,
    gap,
    padding,
    margin,
    border
);
export const FlexRow = styled("div")(
    {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "1rem",
    },
    flexbox,
    gap,
    padding,
    margin,
    border,
    layout
);
export const FlexColumn = styled("div")(
    { display: "flex", flexDirection: "column", gap: "1rem" },
    flexbox,
    gap,
    padding,
    margin,
    border,
    borderRadius,
    layout
);

export const FlexColumnNoGap = styled("div")(
    { display: "flex", flexDirection: "column", gap: "0.5rem" },
    flexbox,
    gap,
    padding,
    margin,
    border,
    borderRadius,
    layout
);
